import { GatheringFields } from 'main/gql/gathering'
import { GatheringType } from 'main/gql/globalTypes'

const labels = {
  event: 'Event',
  groupTour: 'Group Tour',
  openHouse: 'Open House',
}

const labelManifest = {
  [GatheringType.ARTS_AND_CRAFTS]: labels.openHouse,
  [GatheringType.GROUP_TOUR]: labels.groupTour,
  [GatheringType.MUSIC_CIRCLE]: labels.openHouse,
  [GatheringType.OPEN_HOUSE]: labels.openHouse,
  [GatheringType.OTHER]: labels.event,
  [GatheringType.PETTING_ZOO]: labels.openHouse,
  [GatheringType.PLAY_DATE]: labels.openHouse,
  [GatheringType.READING_CIRCLE]: labels.openHouse,
}

export function labelForGathering({ type }: GatheringFields) {
  return labelManifest[type]
}
